// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "11bb963d1dd846c0366df2a687fd8443" + ".js";
};